module.exports = __webpack_public_path__ + "img/blueCircle.d4c305e6.svg";